export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7106.16269e6b.jpg";